@if (productAttributes().length) {
  <h4 class="select-variant mt-3 mb-4">
    {{ 'Order.SelectVariant' | translate }}
  </h4>
  <p-accordion [expandIcon]="'pi pi-plus'" [collapseIcon]="'pi pi-minus'" [value]="productIndex">
    @for (productAttribute of productAttributes(); track productAttribute; let i = $index) {
      <p-accordion-panel [value]="i">
        <p-accordion-header class="bg-transparent">{{ productAttribute.name }}</p-accordion-header>
        <p-accordion-content>
          <div class="mb-2">
            @for (productAttr of productAttribute.productWithAttributes; track productAttr; let j = $index) {
              <div class="mb-2">
                <app-test-selector
                  [productAttribute]="productAttr"
                  [selectedVariantId]="variantID()"
                  (orderTest)="onOrderTest(productAttr.id)"
                  [isOrderCreating]="isOrderCreating">
                  <app-service-card-title
                    [productAttribute]="productAttr"
                    [isOrderCreating]="isOrderCreating"
                    [showGeneContent]="selectedIndex[i] ? selectedIndex[i].includes(j) : false">
                    {{ productAttr.name }}
                    @if (productAttr.noGenes && productAttr.noGenes !== null) {
                      (<p-button
                        (onClick)="onGeneClick($event, productAttr, i, j)"
                        [link]="true"
                        [styleClass]="
                          productAttr.noGenes && productAttr.geneContent
                            ? 'text-primary border-1 inline p-0'
                            : 'text-color border-1 inline p-0'
                        ">
                        {{ productAttr.noGenes }}
                        {{ (productAttr.noGenes > 1 ? 'Common.Genes' : 'Common.Gene') | translate }} </p-button
                      >)
                    }
                  </app-service-card-title>
                </app-test-selector>
              </div>
            }
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    }
  </p-accordion>
}
